var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.path)?_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.path,"id":"personImage"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }